import SEventDetails from "./SEventDetails_web"
export default SEventDetails
